import {Tooltip, TooltipProps} from "antd";
import styled from "styled-components";
import {FC} from "react";

export const TooltipStyled: FC<TooltipProps> = styled(Tooltip)`
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
`